import React, { useState, useEffect } from 'react';
import { Modal, message } from 'antd';
import Select from '../../../../Components/Select';
import TextareaComponent from '../../../../Components/Textarea';
import { getMedications } from '../../../../services/kollectaHealthCore';
import styles from './style.module.css';
import LeftIcon from './leftIcon.svg';

const NovoTratamentoModal = ({ visible, onClose, onSave }) => {
  const [medicationData, setMedicationData] = useState({
    medication: '',
    interval: '',
    observations: '',
    dosage: '-'
  });

  const [medicationsList, setMedicationsList] = useState([]);
  const [medications, setMedications] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchMedications = async () => {
      try {
        setLoading(true);
        const response = await getMedications();
        setMedications(response.data || []);
      } catch (error) {
        console.error('Erro ao buscar medicamentos:', error);
      } finally {
        setLoading(false);
      }
    };

    if (visible) {
      fetchMedications();
    }
  }, [visible]);

  const handleMedicationDataChange = (field, value) => {
    console.log('handleMedicationDataChange:', field, value);
    const actualValue = value?.target?.value || value;
    setMedicationData(prevState => ({
      ...prevState,
      [field]: actualValue
    }));
  };

  const handleAddMedication = () => {
    console.log('handleAddMedication - medicationData:', medicationData);
    if (medicationData.medication && medicationData.interval) {
      const selectedMedication = medications.find(med => med.id === medicationData.medication);
      console.log('Medicamento selecionado:', selectedMedication);
      
      const newMedication = { 
        ...medicationData,
        medicationName: selectedMedication?.name || medicationData.medication
      };
      console.log('Novo medicamento a ser adicionado:', newMedication);
      
      setMedicationsList(prevList => {
        const newList = [...prevList, newMedication];
        console.log('Nova lista de medicamentos:', newList);
        return newList;
      });
      
      setMedicationData(prev => ({
        ...prev,
        medication: '',
        interval: '',
        observations: ''
      }));
    }
  };

  const handleSave = async () => {
    console.log('handleSave - medicationsList antes de enviar:', medicationsList);
    
    // Se houver um medicamento não adicionado à lista, adicione-o antes de salvar
    if (medicationData.medication && medicationData.interval) {
      console.log('Adicionando medicamento pendente antes de salvar:', medicationData);
      
      const selectedMedication = medications.find(med => med.id === medicationData.medication);
      const newMedication = { 
        ...medicationData,
        medicationName: selectedMedication?.name || medicationData.medication
      };
      
      const updatedList = [...medicationsList, newMedication];
      console.log('Lista atualizada com o último medicamento:', updatedList);
      
      // Chama onSave com a lista atualizada
      onSave(updatedList);
    } else {
      // Se não houver medicamento pendente, verifica se há medicamentos na lista
      if (medicationsList.length === 0) {
        message.warning('Nenhum medicamento foi adicionado ao tratamento.');
        return;
      }
      
      console.log('Salvando lista de medicamentos:', medicationsList);
      onSave(medicationsList);
    }
    
    // Limpa o estado
    setMedicationsList([]);
    setMedicationData({
      medication: '',
      interval: '',
      observations: '',
      dosage: '-'
    });
    onClose();
  };

  const hasMedicationsToSave = medicationsList.length > 0 || (medicationData.medication && medicationData.interval);

  return (
    <Modal
      title={
        <div className={styles.modalTitle}>
          <img src={LeftIcon} alt="Kollecta Health" />
          <h3>Adicionar medicamentos ao tratamento</h3>
        </div>
      }
      open={visible}
      onCancel={onClose}
      onOk={handleSave}
      okText="Salvar"
      cancelText="Cancelar"
      width={800}
      className={styles.novoTratamentoModal}
      okButtonProps={{ 
        disabled: !hasMedicationsToSave
      }}
    >
      <div className={styles.modalContent}>
        {medicationsList && medicationsList.length > 0 && (
          <div className={styles.medicationsList}>
            <h3>Medicamentos Adicionados:</h3>
            <ul>
              {medicationsList.map((med, index) => (
                <li key={index}>
                  {med.medicationName} - {med.interval}
                  {med.observations && ` - Obs: ${med.observations}`}
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className={styles.formSection}>
          <div className={styles.medicationRow}>
            <div className={styles.formGroup}>
              <label htmlFor="medication">Medicamento</label>
              <Select
                options={medications.map(med => ({ value: med.id, label: med.name }))}
                value={medicationData.medication}
                onChange={(value) => handleMedicationDataChange('medication', value)}
                label=""
                fullWidth
                disabled={loading}
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="interval">Intervalo</label>
              <Select
                options={[
                  { value: "4/4h", label: "4/4h" },
                  { value: "6/6h", label: "6/6h" },
                  { value: "8/8h", label: "8/8h" },
                  { value: "12/12h", label: "12/12h" },
                  { value: "24/24h", label: "24/24h" },
                  { value: "72h", label: "72h" },
                  { value: "7_dias", label: "7 dias" },
                  { value: "uso_personalizado", label: "Uso personalizado" }
                ]}
                value={medicationData.interval}
                onChange={(value) => handleMedicationDataChange('interval', value)}
                label=""
                fullWidth
              />
            </div>
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="observations">Observações</label>
            <TextareaComponent
              onValueChange={(value) => handleMedicationDataChange('observations', value)}
              value={medicationData.observations}
            />
          </div>

          <div className={styles.formGroup}>          
            <button 
              type="button"
              className={`${styles.btnPrimary} ${styles.btnGray}`}
              onClick={handleAddMedication}
              disabled={!medicationData.medication || !medicationData.interval || loading}
            >
              + Adicionar mais medicamentos à lista
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default NovoTratamentoModal; 